import React from "react";
import { Box, Typography } from "@mui/material";
import { VIEWER_TOP_OFFSET_PX } from "./viewerLayout";

/**
 * Affiché à la place du configurateur 3D lorsqu'aucun produit ne correspond
 * aux dimensions / options d'installation.
 */
const NoProductView = () => (
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      top: `${VIEWER_TOP_OFFSET_PX}px`,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 2,
      px: 3,
      textAlign: "center",
      backgroundColor: "#fafafa",
      zIndex: 2,
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: 600, color: "text.secondary" }}>
      Aucun modèle disponible
    </Typography>
    <Typography variant="body2" sx={{ color: "text.secondary", maxWidth: 360 }}>
      Aucun produit ne correspond à cette configuration.
    </Typography>
  </Box>
);

export default NoProductView;
